// Sortable list optimized for mobile execution views.
import { Typography } from '@mui/material';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import TaskItemSwipeable from '@/features/tasks/components/items/TaskItemSwipeable';
import TaskItemToday from '@/features/tasks/components/items/TaskItemToday';
import TaskItemMobileSortable from '@/features/tasks/components/items/TaskItemMobileSortable';
import { generateBreadcrumbPath } from '@/features/tasks/utils/structure/taskHierarchy';
import TodayEmptyMessageContent from '@/features/today/components/TodayEmptyMessageContent';

const TaskListSortableMobile = ({
  displayTasks,
  totalTasksCount,
  listId,
  taskType,
  leftSwipeAction,
  topActionableTaskId,
  showPlayButtonAlways,
  tasksMap,
  inProgressMessage,
  emptyMessage,
  swipeTeaserTaskId = null,
  onSwipeTeaserEnd,
}) => (
  <>
    {displayTasks.length > 0 ? (
      <SortableContext
        items={displayTasks.map((t) => t.id)}
        strategy={verticalListSortingStrategy}
        id={listId}
      >
        {displayTasks.map((task) => (
          <TaskItemMobileSortable key={task.id} task={task} type={taskType}>
            <TaskItemSwipeable
              task={task}
              leftSwipeAction={leftSwipeAction}
              swipeTeaserActive={swipeTeaserTaskId === task.id}
              onSwipeTeaserEnd={onSwipeTeaserEnd}
            >
              <TaskItemToday
                task={task}
                indentationType="none"
                view="today"
                showPlayButton={
                  showPlayButtonAlways || task.id === topActionableTaskId
                }
                breadcrumb={
                  task.breadcrumb ||
                  (tasksMap
                    ? generateBreadcrumbPath(task, tasksMap)
                    : undefined)
                }
              />
            </TaskItemSwipeable>
          </TaskItemMobileSortable>
        ))}
      </SortableContext>
    ) : totalTasksCount > 0 ? (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontStyle: 'italic', opacity: 0.7 }}
      >
        {inProgressMessage}
      </Typography>
    ) : (
      <TodayEmptyMessageContent>{emptyMessage}</TodayEmptyMessageContent>
    )}
  </>
);

export default TaskListSortableMobile;
